import React from 'react';
import { useTranslation } from "react-i18next";

const EmissionString = ({emission}) => {
    const emissionMapping = {
        "CO_gs": "emission.CO_gs",
        "CO_mgm3": "emission.CO_mgm3",
        "DUST": "emission.DUST",
        "FLOW": "emission.FLOW",
        "HUMIDITY": "emission.HUMIDITY",
        "NO_gs": "emission.NO_gs",
        "NO_mgm3": "emission.NO_mgm3",
        "NO2_gs": "emission.NO2_gs",
        "NO2_mgm3": "emission.NO2_mgm3",
        "NOx_gs": "emission.NOx_gs",
        "NOx_mgm3": "emission.NOx_mgm3",
        "O2": "emission.O2",
        "PT": "emission.PT",
        "SO2_gs": "emission.SO2_gs",
        "SO2_mgm3": "emission.SO2_mgm3",
        "TEMP": "emission.TEMP"
    };

    const {t} = useTranslation();

    return emissionMapping[emission.name] ? t(emissionMapping[emission.name]) : null;
};

export default EmissionString;